import React, { useState } from 'react';
import Table, { columnType } from '../../components/ClearingTable/Table';
import Button from '../../components/Buttons/Button';
import AutoCompleteAccountNo from '../../components/AutoComplete/AutoCompleteAccountNo';
import SelectSystemCode from '../../components/Dropdown/SelectSystemCode';
import Text from '../../components/Typography/Text';
import { notifyInfo, notifyError } from '../../components/Messages/Notification';
import { listAccountContact } from '../../services/AccountContactService';
import QueryParam from '../../services/QueryParamService';
import { CustomBodyRenderHtmlString } from '../../components/Table/CustomBodyRender';

export default function AccountContact() {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);
  const [pagination, setPagination] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [previousRows, setPreviousRows] = useState(0);
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      accountNo: '',
      status: 'Active',
    })
  );

  const columns = [
    {
      name: '',
      label: '',
      type: columnType.buttons,
    },
    {
      name: 'accountId',
      label: 'Account ID',
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'accountName',
      label: 'Account Name',
    },
    {
      name: 'fullName',
      label: 'Full Name',
    },
    {
      name: 'email',
      label: 'Email(s)',
      options: {
        filterType: 'textField',
      },
    },
    {
      name: 'phone',
      label: 'Phone No(s)',
      options: {
        customBodyRender: CustomBodyRenderHtmlString,
        filterType: 'textField',
      },
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    serverSide: true,
    selectableRows: 'none',
    responsive: 'standard',
  };

  const handleSearchDataChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    if (input.name === 'accountNo') {
      searchData.accountId = input.data ? input.data.accountId : 0;
    }

    setSearchData({ ...searchData, [input.name]: input.value });
  };

  const handleSearch = async (paginationChange) => {
    try {
      setLoading(true);
      QueryParam.set(searchData);
      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };
      if (previousRows !== 0) {
        if (previousRows < pagination.rowsPerPage * pagination.pageNo) {
          paginationCopy.pageNo = 0;
        }
      }
      if (paginationChange !== true) {
        paginationCopy.filterNames = [];
        paginationCopy.filterValues = [];
      }

      const data = await listAccountContact(searchData, paginationCopy);
      let rowsCopy = data.accountContactsList;

      rowsCopy = rowsCopy.map((r) => {
        r.phone = r.phone.replaceAll('**', '</br>');
        return r;
      });
      setSearchDataCsv(searchData);
      setTotalRows(data.summary.totalRows);
      setPreviousRows(totalRows);
      paginationCopy.count = data.summary.totalRows;
      setPagination(paginationCopy);
      setRows(rowsCopy);
      if (paginationChange !== true) {
        notifyInfo(data.summary.totalRows + ' search results.');
      }
    } catch (error) {
      setLoading(false);
      notifyError(error.message);
      console.log(error);
      return;
    } finally {
      setLoading(false);
    }
  };

  const getCsvData = async () => {
    if (totalRows === 0) {
      return [];
    }
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };
    const data = await listAccountContact(searchDataCsv, paginationCopy);

    return data?.accountContactsList;
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Account Contact" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading}
              loading={loading}
              type="search"
              label={loading ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <AutoCompleteAccountNo
              isAccessibleOnly={true}
              name="accountNo"
              value={searchData.accountNo}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              name="status"
              label="Status"
              type="Status"
              subType="AI"
              placeholder="Status"
              value={searchData.status}
              onChange={handleSearchDataChange}
            ></SelectSystemCode>
          </div>
        </div>
      </div>
      <div className="mt-20">
        <Table
          title={'Account Contact'}
          data={rows}
          columns={columns}
          options={options}
          getCsvData={getCsvData}
          pagination={pagination}
          setPagination={setPagination}
          onSearch={handleSearch}
        />
      </div>
    </form>
  );
}
